module.exports = __webpack_public_path__ + "static/media/icon.a7984a8b.png";